<div class="min-h-screen flex flex-col items-center justify-center px-6 bg-cloud-mist font-sans">
  <div class="w-full max-w-md">

    <div class="flex justify-center mb-8">
      <div class="h-20 w-20 rounded-3xl flex items-center justify-center bg-pale-gray">
        <svg class="h-10 w-10 text-slate-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
        </svg>
      </div>
    </div>

    <div class="tfr-auth-card max-w-md mx-auto">
      <h1 class="text-[22px] font-bold text-center tracking-tight mb-2 text-midnight-indigo">
        Verifica tu email
      </h1>
      <p class="text-[13px] text-center leading-relaxed mb-1 text-slate-blue">
        Hemos enviado un enlace de verificación a
      </p>
      <p class="text-[13px] font-semibold text-center mb-6 truncate text-midnight-indigo">
        {{ authUser()?.email ?? '...' }}
      </p>
      <p class="text-[12px] text-center leading-relaxed mb-8 text-steel-gray">
        Haz clic en el enlace del correo para activar tu cuenta.
        Después vuelve aquí y pulsa el botón.
      </p>

      <button type="button" (click)="checkVerification()" [disabled]="checking()" class="tfr-btn-primary--full">
        @if (checking()) { Comprobando… } @else { He verificado mi email }
      </button>

      @if (error()) {
        <div class="tfr-callout mt-4">
          <svg class="shrink-0 mt-0.5 h-3.5 w-3.5 text-steel-gray" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <p class="text-[12px] leading-snug text-slate-blue">{{ error() }}</p>
        </div>
      }

      <div class="mt-6 text-center">
        @if (resent()) {
          <p class="text-[12px] text-steel-gray">Correo reenviado. Revisa tu bandeja de entrada.</p>
        } @else {
          <button type="button" (click)="resendVerification()" [disabled]="resending()" class="tfr-link-muted text-[12px] disabled:opacity-50">
            {{ resending() ? 'Enviando…' : 'Reenviar correo de verificación' }}
          </button>
        }
      </div>
    </div>

    <p class="mt-6 text-center text-[12px] text-steel-gray">
      ¿Email incorrecto?
      <button type="button" (click)="signOut()" class="tfr-link-muted text-[12px] ml-1">Cerrar sesión</button>
    </p>
  </div>
</div>
